export { default as Tabs } from './Tabs';
export * as Styled from './Tabs.styles';
